import api from './api'

const FacturaVentaService = {}

FacturaVentaService.consultarElectronica = async function(id){
    return api.get('/FacturaVenta/Electronicas/'+id).then(res => res.data);
}

FacturaVentaService.consultarElectronicasCliente = async function(id) {
    return api.get('/FacturaVenta/Electronicas/Cliente/'+id).then(res => res.data);
}

FacturaVentaService.consultarQr = async function(id) {
    return api.get('/FacturaVenta/QR/'+id).then(res => res.data);
}

FacturaVentaService.consultarCuadroTotales = async function(id) {
    return api.get('/FacturaVenta/CuadroTotales/'+id).then(res => res.data);
}

FacturaVentaService.consultarOtrosTributos = async function(id) {
    return api.get('/FacturaVenta/OtrosTributos/'+id).then(res => res.data);
}

FacturaVentaService.consultarCaractCabecera = async function(id) {
    return api.get('/FacturaVenta/CaracteristicasCabecera/'+id).then(res => res.data);
}
export default FacturaVentaService